import { FastField, Formik } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import AppColors from 'general/constants/AppColors';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

ViewAddInvestorGroupPack.propTypes = {
  onClosed: PropTypes.func,
  onSubmitted: PropTypes.func,
  item: PropTypes.object,
};

function ViewAddInvestorGroupPack(props) {
  // MARK: ---- params ----
  const { onClosed, onSubmitted, item } = props;
  const { t } = useTranslation();
  const isEditMode = !_.isUndefined(item);

  return (
    <div>
      <Formik
        initialValues={{
          name: item?.name ?? '',
          price: item?.amount ?? '',
          description: item?.description ?? '',
        }}
        enableReinitialize={true}
        validationSchema={Yup.object({
          name: Yup.string().required('Bắt buộc')
            .test('len', t('invalid', { field: 'name' }), (val) => {
              if (val) {
                return val.toString().trim();
              }
            }),
          price: Yup.number().required('Bắt buộc')
            .positive(t('Giá gói đầu tư phải lớn hơn 0')),
        })}
        onSubmit={(values) => {
          if (onSubmitted) {
            onSubmitted(values);
          }
        }}
      >
        {(formikProps) => (
          <div className="">
            <div
              className="row p-6 m-0"
              style={{
                backgroundColor: AppColors.gray[100],
              }}
            >
              {/* name */}
              <div className="col-12 p-0">
                <KTFormGroup
                  label={<span className="font-weight-bolder">{t('Tên gói')} </span>}
                  inputName="name"
                  isRequired={true}
                  inputElement={
                    <FastField name="name">
                      {({ field, form, meta }) => {
                        return (
                          <KTFormInput
                            name={field.name}
                            value={field.value}
                            onChange={(value) => {
                              form.setFieldValue(field.name, value);
                            }}
                            onBlur={() => {
                              form.setFieldTouched(field.name, true);
                            }}
                            enableCheckValid
                            type={KTFormInputType.text}
                            placeholder={t('Nhập tên gói')}
                            isValid={_.isEmpty(meta.error)}
                            isTouched={meta.touched}
                            feedbackText={meta.error}
                          />
                        );
                      }}
                    </FastField>
                  }
                />
              </div>
              {/* price */}
              <div className="col-12 p-0">
                <KTFormGroup
                  label={<span className="font-weight-bolder">{t('Giá bán')} </span>}
                  inputName="price"
                  isRequired={true}
                  inputElement={
                    <FastField name="price">
                      {({ field, form, meta }) => {
                        return (
                          <KTFormInput
                            name={field.name}
                            value={field.value}
                            onChange={(value) => {
                              form.setFieldValue(field.name, value);
                            }}
                            onBlur={() => {
                              form.setFieldTouched(field.name, true);
                            }}
                            enableCheckValid
                            type={KTFormInputType.currency}
                            placeholder={t('Nhập số')}
                            isValid={_.isEmpty(meta.error)}
                            isTouched={meta.touched}
                            feedbackText={meta.error}
                          />
                        );
                      }}
                    </FastField>
                  }
                />
              </div>
              {/* description */}
              <div className="col-12 p-0">
                <KTFormGroup
                  label={<span className="font-weight-bolder">{t('Mô tả')} </span>}
                  inputName="description"
                  additionalClassName="mb-0"
                  inputElement={
                    <FastField name="description">
                      {({ field, form, meta }) => {
                        return (
                          <KTFormTextArea
                            name={field.name}
                            value={field.value}
                            onChange={(value) => {
                              form.setFieldValue(field.name, value);
                            }}
                            onBlur={() => {
                              form.setFieldTouched(field.name, true);
                            }}
                            enableCheckValid={false}
                            type={KTFormInputType.text}
                            placeholder={t('Nhập thông tin mô tả')}
                            isValid={_.isEmpty(meta.error)}
                            isTouched={meta.touched}
                            feedbackText={meta.error}
                            rows={5}
                          />
                        );
                      }}
                    </FastField>
                  }
                />
              </div>
            </div>

            {/* actions */}
            <div className="d-flex align-items-center gap-3 justify-content-end bg-white p-6 border-top rounded-bottom-lg">
              <KTBSButton
                color={KTBSButtonColor.secondary}
                title={t('cancel')}
                size={KTBSButtonSize.large}
                borderRadius={5}
                buttonTitleFontWeight="600"
                onPress={onClosed}
                buttonTitleColor={'rgba(74, 86, 119, 1)'}
              // additionalClassName="w-100"
              />
              <KTBSButton
                color={KTBSButtonColor.success}
                title={!isEditMode ? t('Thêm') : t('Cập nhật')}
                size={KTBSButtonSize.large}
                borderRadius={5}
                buttonTitleFontWeight="600"
                onPress={() => {
                  formikProps.handleSubmit();
                }}
              // additionalClassName="w-100"
              />
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default ViewAddInvestorGroupPack;
